"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInputSlider = void 0;

var _react = _interopRequireDefault(require("react"));

var useInputSlider = function useInputSlider(_ref) {
  var max = _ref.max,
      min = _ref.min,
      value = _ref.value,
      onChange = _ref.onChange;

  var _react$default$useSta = _react.default.useState(value),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      range = _react$default$useSta2[0],
      setRange = _react$default$useSta2[1];

  var getFilledPercentage = function getFilledPercentage(currentValue) {
    var interval = max - min;
    var start = currentValue - min;
    var percentage = start * 100 / interval;
    return percentage;
  };

  var onInputChange = function onInputChange(event) {
    var currentValue = event.target.value;
    setRange(currentValue);

    if (onChange) {
      onChange({
        value: currentValue,
        filled: getFilledPercentage(currentValue)
      });
    }
  };

  return {
    range: range,
    filled: getFilledPercentage(range),
    onInputChange: onInputChange
  };
};

exports.useInputSlider = useInputSlider;